<template>
    <div class="title">
        <div class="title_box">
            <div :style="{'display':'flex','align-items':'center'}">
                <div class="img_icon"><img src="../assets/img/icon.png" alt=""></div>
                <div class="txt">
                    <p :style="{'font-size':'28px','font-weight':'bold'}">羽毛球成绩网站</p>
                    <p :style="{'font-size':'20px'}">Badminton Results</p>
                </div>
            </div>
            <div class="nav_btn">
                <span><i class="iconfont icon-daohang" @click="drawer = true"></i></span>
            </div>
        </div>

        <el-drawer
        title="我是标题"
        :with-header="false"
        :visible.sync="drawer"
        size="15%"
        direction="rtl"
        >
            <div>
                <ul class="nav_list">
                    <li><span @click="handlePage('1')">首页</span></li>
                    <li><span @click="handlePage('2')">赛事列表</span></li>
                    <!-- <li><span @click="handlePage('3')">商务合作</span></li> -->
                </ul>
            </div>
        </el-drawer>


    </div>
</template>

<script>
export default {
    data() {
        return {
            drawer: false,
        }
    },
    mounted() {
        
    },
    methods: {
        handlePage(index){
            // console.log(this.$route);
            // console.log(this.$router);
            let randomNum = Math.random(); // 这里的范围根据需求进行调整
            if( index == 1){
                if(this.$route.name == 'PHome'){
                    return false;
                }else{
                    // this.$router.push('/GameResult');
                    this.$router.push({
                        path: '/PHome', 
                        query: { v: randomNum }
                    });
                }
            }else if(index == 2){
                if(this.$route.name == 'Sports'){
                    return false;
                }else{
                    // this.$router.push('/GameResult');
                    this.$router.push({
                        path: '/Sports', 
                        query: { v: randomNum }
                    });
                }
            }else if(index == 3){
                if(this.$route.name == 'GameResult'){
                    return false;
                }else{
                    // this.$router.push('/GameResult');
                    this.$router.push({
                        path: '/GameResult', 
                        query: { v: randomNum }
                    });
                }
            }else{
                return false
            }
        }
    },
}
</script>

<style lang="scss" scoped>
    $color: #3641C9;
    ::v-deep .el-drawer{
        // background: rgba(255, 255, 255, 0.5);
        // opacity:0.3;
        background: none;
    }
    ::v-deep .el-drawer__body{
        background: $color;
        color: white;
        border-radius: 10px 0 0 10px;
    }
    .title_box{
        width: 1400px;
        display: flex;
        margin: 0 auto;
        padding: 40px 0;
        align-items: center;
        justify-content: space-between;
        .txt{
            color: white;
        }
        .nav_btn{
            color: $color;
            i {
                font-size: 50px;
            }
        }
    }
    .img_icon{
        width: 30px;
        margin-right: 5px;
        // height: 40px;
        img{
            width: 100%;
            vertical-align: middle;
        }
    }
    .nav_list{
        width: 60%;
        position: absolute;
        left: 50%;
        top: 0%;
        transform: translate(-50%);
        li{
            // width: 50%;
            // margin: 0 auto;
            text-align: center;
            padding: 40px 0;
            font-size: 30px;
            border-bottom: 2px solid;
            // border-image: linear-gradient(to right, white, #3641C9);
            border-image: radial-gradient(circle, white, #3641C9);
            border-image-slice: 1;
            span{
                cursor: pointer;
            }
        }
    }
</style>